import React from 'react';
import { Space, Input, Select, Button, Popconfirm } from 'antd';
import { SearchOutlined, CloudDownloadOutlined, ReloadOutlined } from '@ant-design/icons';

interface SearchFilterBarProps {
    searchKeyword: string;
    onSearchChange: (val: string) => void;
    onSearch: () => void;
    sortBy: string;
    sortOrder: string;
    onSortChange: (field: string, order: string) => void;
    statusFilter: string | undefined;
    onStatusChange: (val: string | undefined) => void;
    bulkScraping: boolean;
    onBulkScrape: (force?: boolean) => void;
    refreshing: boolean;
    onRefresh: () => void;
}

export const SearchFilterBar: React.FC<SearchFilterBarProps> = ({
    searchKeyword, onSearchChange, onSearch,
    sortBy, sortOrder, onSortChange,
    statusFilter, onStatusChange,
    bulkScraping, onBulkScrape,
    refreshing, onRefresh
}) => {
    return (
        <div className="posts-toolbar">
            <Space>
                <Input.Search
                    placeholder="搜索帖子标题..."
                    allowClear
                    style={{ width: 250 }}
                    value={searchKeyword}
                    onChange={e => onSearchChange(e.target.value)}
                    onSearch={onSearch}
                    enterButton={<SearchOutlined />}
                />
                <Select
                    placeholder="排序方式"
                    style={{ width: 140 }}
                    value={`${sortBy}_${sortOrder}`}
                    onChange={(value) => {
                        const [by, order] = value.split('_');
                        onSortChange(by, order);
                    }}
                    options={[
                        { value: 'reply_count_desc', label: '回复数↓' },
                        { value: 'reply_count_asc', label: '回复数↑' },
                        { value: 'post_time_desc', label: '发布时间↓' },
                        { value: 'post_time_asc', label: '发布时间↑' },
                    ]}
                />
                <Select
                    placeholder="抓取状态"
                    allowClear
                    style={{ width: 120 }}
                    value={statusFilter}
                    onChange={onStatusChange}
                    options={[
                        { value: 'pending', label: '待抓取' },
                        { value: 'scraped', label: '已抓取' },
                        { value: 'failed', label: '失败' },
                    ]}
                />
            </Space>
            <Space>
                <Button
                    type="primary"
                    icon={<CloudDownloadOutlined />}
                    loading={bulkScraping}
                    onClick={() => onBulkScrape(false)}
                >
                    批量抓取
                </Button>
                <Button
                    icon={<ReloadOutlined spin={refreshing} />}
                    onClick={onRefresh}
                    loading={refreshing}
                >
                    从网站刷新
                </Button>
                <Popconfirm
                    title="确定要重置所有状态并重新抓取吗？"
                    description="这将把所有帖子标记为'待抓取'并开始后台任务。"
                    onConfirm={() => onBulkScrape(true)}
                    okText="重置并抓取"
                    cancelText="取消"
                >
                    <Button danger loading={bulkScraping} icon={<ReloadOutlined />}>
                        重置并抓取
                    </Button>
                </Popconfirm>
            </Space>
        </div>
    );
};
